import { render, staticRenderFns } from "./CPageButtons.vue?vue&type=template&id=4dbf1bf9&"
import script from "./CPageButtons.vue?vue&type=script&lang=ts&"
export * from "./CPageButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports